module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "loading-content"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/loading.gif")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.topic.title) ? _c('div', {
    attrs: {
      "id": "detail"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', [_c('span', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.topic.title))])]), _vm._v(" "), _c('div', {
    staticClass: "title-info"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'User',
        params: {
          loginname: _vm.topic.author.loginname
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.topic.author.loginname))]), _vm._v(" 发表于\n        "), _c('span', [_vm._v(_vm._s(_vm._f("getLastTime")(_vm.topic.create_at)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.topic.visit_count))]), _vm._v(" 次浏览\n        "), _c('span', [_vm._v(_vm._s(_vm.topic.reply_count))]), _vm._v(" 个回复\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-body markdown-body",
    attrs: {
      "id": "main"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.topic.content)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "comment"
    }
  }, [_c('div', {
    staticClass: "comment-header"
  }, [_vm._v("\n        回复 "), _c('span', {
    staticClass: "reply-num"
  }, [_vm._v(_vm._s(_vm.topic.reply_count) + " 个")]), _vm._v(" "), _c('span', {
    staticClass: "replay-middle"
  }), _vm._v("\n        最新 "), _c('span', {
    staticClass: "last-reply"
  }, [_vm._v(_vm._s(_vm._f("getLastTime")(_vm.topic.last_reply_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "comment-main"
  }, [_c('ul', {
    staticClass: "comment-list"
  }, _vm._l((_vm.topic.replies), function(item, key) {
    return _c('li', [_c('div', {
      staticClass: "reply-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'User',
          params: {
            loginname: item.author.loginname
          }
        }
      }
    }, [_c('span', {
      staticClass: "reply-user"
    }, [_vm._v(_vm._s(item.author.loginname))])]), _vm._v("\n              发布于 "), _c('span', {
      staticClass: "reply-time"
    }, [_vm._v(_vm._s(_vm._f("getLastTime")(item.create_at)))]), _vm._v(" "), _c('span', {
      staticClass: "reply-floor",
      on: {
        "click": function($event) {
          _vm.replyOne(item.author.loginname)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-reply"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "markdown-body",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "reply"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.commentFocus),
      expression: "commentFocus"
    }],
    staticClass: "text",
    attrs: {
      "rows": "6",
      "placeholder": "支持Markdown语法"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.submitComment
    }
  }, [_vm._v("确定")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-66d93562"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/detail.vue
// module id = 154
// module chunks = 1